
import {defineComponent, onMounted, ref} from 'vue';
import {getNowPlayingMovies, getPopularMovies, getTopRatedMovies, getUpcomingMovies} from "@/service/MoviesService";
import MovieModal from "@/components/MovieModal.vue";
import MoviesCarousel from "@/components/MoviesCarousel.vue";
import MoviesBanner from "@/components/MoviesBanner.vue";

export default defineComponent({
  name: 'HomeView',
  components: {
    MoviesCarousel,
    MoviesBanner,
    MovieModal,
  },
  setup() {
    const popularMovies = ref();
    const bannerMovies = ref();
    const upcomingMovies = ref();
    const topMovies = ref();
    const nowPlaying = ref();
    const movieId = ref();
    const showModal = ref(false)

    onMounted(() => {
      getPopularMovies()
          .then(response => {
            popularMovies.value = response.data.results
            bannerMovies.value = response.data.results?.slice(0, 5)
          })
      getUpcomingMovies()
          .then(response => upcomingMovies.value = response.data.results)
      getTopRatedMovies()
          .then(response => topMovies.value = response.data.results)
      getNowPlayingMovies()
          .then(response => nowPlaying.value = response.data.results)
    })

    const getMovieData = (id: number) => {
      movieId.value = id;
      showModal.value = true;
    }

    const cleanModalData = () => {
      movieId.value = null;
      showModal.value = false;
    }

    return {
      cleanModalData,
      popularMovies,
      bannerMovies,
      nowPlaying,
      topMovies,
      upcomingMovies,
      movieId,
      getMovieData,
      showModal
    }
  }
});
